export const THEME_KEY = "divedix-store-theme";

const THEME_COLORS = {
  light: {
    page: "#f7f8ff",
    background: "linear-gradient(145deg, #f7f8ff, #eef2ff 55%, #edf7ff)",
  },
  dark: {
    page: "#0c0d1c",
    background: "linear-gradient(145deg, #0c0d1c, #151936 55%, #101b35)",
  },
};

export function getStoredTheme() {
  const storedTheme = localStorage.getItem(THEME_KEY);
  return storedTheme === "dark" ? "dark" : "light";
}

export function applyDocumentTheme(value) {
  const theme = value === "dark" ? "dark" : "light";
  const colors = THEME_COLORS[theme];
  const root = document.documentElement;

  root.dataset.theme = theme;
  root.style.colorScheme = theme;
  root.style.background = colors.page;
  root.style.setProperty("--initial-page-bg", colors.background);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", colors.page);
  localStorage.setItem(THEME_KEY, theme);
}
